import { z } from 'zod';

// zog's default email schema can't handle czech symbols ;(
const emailRegex = /^[a-zA-Z0-9._%+-č]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const email = z
  .string()
  .regex(emailRegex, { message: 'Nesprávná email adresa' });
